import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-188e35bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "social-proof" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"customer-avatars\" data-v-188e35bc><img src=\"/media/Testamonial_Josh.webp\" alt=\"Customer\" class=\"avatar\" data-v-188e35bc><img src=\"/media/Testamonial_James.webp\" alt=\"Customer\" class=\"avatar\" data-v-188e35bc><img src=\"/media/Testamonial_Michael.webp\" alt=\"Customer\" class=\"avatar\" data-v-188e35bc><img src=\"/media/Testamonial_Emma.webp\" alt=\"Customer\" class=\"avatar\" data-v-188e35bc><img src=\"/media/Testamonial_Ava.webp\" alt=\"Customer\" class=\"avatar\" data-v-188e35bc></div><div class=\"rating\" data-v-188e35bc><i class=\"bi bi-star-fill text-warning\" data-v-188e35bc></i><i class=\"bi bi-star-fill text-warning\" data-v-188e35bc></i><i class=\"bi bi-star-fill text-warning\" data-v-188e35bc></i><i class=\"bi bi-star-fill text-warning\" data-v-188e35bc></i><i class=\"bi bi-star-fill text-warning\" data-v-188e35bc></i></div>", 2)
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "highlight-number" }, "10,000+ ", -1))
const _hoisted_5 = {
  key: 1,
  class: "proof-text text-muted"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TestimonialsMini',
  props: {
  darkMode: {
    type: Boolean,
    default: true,
  },
  description: {
    type: String
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!__props.description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["proof-text", { 'text-dark': !__props.darkMode }])
        }, [
          _createTextVNode(" Join "),
          _hoisted_4,
          _createTextVNode(" job seekers getting hired ")
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.description), 1))
  ]))
}
}

})